import React from 'react';

import {CrossIcon, TickIcon} from '../icons';
import Text from '../TextComponents/Text';
import type {TextColours} from '../TextComponents/textUtils';

const isValidationStateDisplayed = (
  showInvalidState: boolean,
  showValidState: boolean,
  reserveValidationSpace: boolean
) => {
  if (reserveValidationSpace || showInvalidState || showValidState) {
    return true;
  }
  return false;
};

const isValidationIconDisplayed = (
  showInvalidState: boolean,
  showValidState: boolean,
  showValidationIcon?: boolean
) => {
  if (!showValidationIcon) {
    return false;
  }
  return (
    (showInvalidState === true && showValidState === false) || showValidState
  );
};

const getErrorTextId = (text?: string, shown?: boolean, id?: string) =>
  text && shown ? id : '';

// eslint-disable-next-line complexity
export const renderValidationText = (options: {
  errorText?: string;
  showInvalidState: boolean;
  successText?: string;
  showValidState: boolean;
  reserveValidationSpace: boolean;
  errorTextId?: string;
  isPrefilled?: boolean;
  showValidationIcon?: boolean;
}) => {
  const {
    errorText,
    showInvalidState,
    successText,
    showValidState,
    reserveValidationSpace = true,
    errorTextId,
    isPrefilled,
    showValidationIcon = true,
  } = options;
  const showValidationState = isValidationStateDisplayed(
    showInvalidState,
    showValidState,
    reserveValidationSpace
  );
  let status = '';
  let validationText;
  let colour: TextColours = 'textPrimary';
  if (errorText && showInvalidState) {
    status = 'invalid';
    validationText = errorText;
    colour = 'red';
  } else if (successText && showValidState) {
    status = 'valid';
    validationText = successText;
    colour = 'green';
  }
  const showIcon = isValidationIconDisplayed(
    showInvalidState,
    showValidState,
    showValidationIcon
  );

  if (!showValidationState || isPrefilled || !validationText) {
    return false;
  }
  return (
    <div
      styleName={`validation-text ${status}`}
      data-automation={`${status}-message`}
    >
      {showIcon && renderValidationIcon(showInvalidState, showValidState)}
      <Text
        size='s'
        weight='medium'
        colour={colour}
        id={getErrorTextId(errorText, showInvalidState, errorTextId)}
      >
        {validationText}
      </Text>
    </div>
  );
};

export const renderValidationIcon = (
  showInvalid: boolean,
  showValid: boolean
) => {
  if (showInvalid) {
    return <CrossIcon colour='errorPrimary' size='xsmall' />;
  }
  if (showValid) {
    return <TickIcon colour='successPrimary' size='xsmall' />;
  }
  return false;
};
